import axios from 'axios';

export default  {


	methods: {

		addRow(arr,obj){
	console.log(obj)
			if(obj==undefined){
				if(arr.length>0){

					obj = clone(arr[0]);
					obj = resetValues(obj);
				} else {
					obj = {}
				}
			}
			arr.push(obj)
		},
		removeRow(arr,index){
			var removed = arr.splice(index,1);
			console.log('removed',removed);
		},
		onFileChange(event,obj,field){
			console.log('file change',obj,field)

			var files = event.target.files || event.dataTransfer.files;

			var file = files[0];
			if(!file) return;
			event.target.value='';

			//this.isUploading = true;

			var reader = new FileReader();
			reader.onload = (e) => {
				var base64 =  e.target.result;
				var data = {
					name:file.name,
					content:base64
				}

				axios.post('/api/upload',data,{
					onUploadProgress: (progressEvent) => {
						const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
						if (totalLength !== null) {
							console.log('progress',Math.round( (progressEvent.loaded * 100) / totalLength ));
								//this.progress = Math.round( (progressEvent.loaded * 100) / totalLength );
							}
						}
					})
				.then((response)=> {
					console.log('upload complete')
					console.log('current value:',obj[field])
					console.log('set new value:',response.data)
					if( obj[field]){
						obj[field] = obj[field].replace(extractUrl(obj[field]),response.data);
					} else {
						obj[field] = response.data;
					}

				})
				.catch((error) =>  {
					console.error(error);
					if(error.response) alert(error.response.data);
				})
			};
			reader.readAsDataURL(file);
		},
		onFileInput(event,fn){
			var files = event.target.files || event.dataTransfer.files;

			var file = files[0];
			if(!file) return;
			event.target.value='';

			var reader = new FileReader();
			reader.onload = (e) => {
				var base64 =  e.target.result;
				var data = {
					name:file.name,
					content:base64
				}

				axios.post('/api/upload',data,{
					onUploadProgress: (progressEvent) => {
						const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
						if (totalLength !== null) {
							console.log('progress',Math.round( (progressEvent.loaded * 100) / totalLength ));
								//this.progress = Math.round( (progressEvent.loaded * 100) / totalLength );
							}
						}
					})
				.then((response)=> {
					fn(file,response.data);
				})
				.catch((error) =>  {
					console.error(error);
					if(error.response) alert(error.response.data);
				})
			};
			reader.readAsDataURL(file);
		}
	}



}
